import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const previewStyle = css`
	display: block;
	max-width: 240px;
	max-height: 64px;
	object-fit: contain;
	border-radius: ${theme.radii.medium};
`;

type Props = {
	readonly dataUrl: string;
	readonly alt: string;
};

const LogoPreview: React.FC<Props> = ({ dataUrl, alt }) => {
	return <img css={previewStyle} src={dataUrl} alt={alt} />;
};

export default LogoPreview;
